import { useEffect, useState } from 'react'
import { translations } from '../../../../configs/translations'
import { useStore } from '../../../../store/store'
import { getTimeFormated } from '../../../../utils/getTimeFormated'
import { EventCountDownState } from '../EventPreparation'

import { useMemo } from 'react'
import './PreparationCountdown.css'

export interface PreparationCountdownProps {
	data: EventCountDownState
}

export const PreparationCountdown = ({ data }: PreparationCountdownProps) => {
	const language = useStore(state => state.language) as keyof typeof translations
	const t = translations[language]

	const [remainingUntilStart, setRemainingUntilStart] = useState(data.remainingUntilStart)

	useEffect(() => {
		const interval = window.setInterval(() => {
			setRemainingUntilStart(prev => Math.max(0, prev - 1000))
		}, 1000)

		return () => {
			window.clearInterval(interval)
		}
	}, [data.remainingUntilStart])

	const timeFormatted = useMemo(() => {
		const remainingUntilStartSafe = Math.max(0, remainingUntilStart)

		const remainingMinutes = Math.floor(remainingUntilStartSafe / 60000)
		const remainingSeconds = Math.floor((remainingUntilStartSafe % 60000) / 1000)

		return getTimeFormated(null as never, remainingMinutes, remainingSeconds).split(',')[0]
	}, [remainingUntilStart])

	return (
		<div className={`preparation-countdown`}>
			<p className='preparation-countdown-event-name'>{data.eventName}</p>
			<p>{t.event_starts_in}: <span className='weight-400'>{timeFormatted}</span></p>
			<p>{t.players5}: <span className='weight-400'>{data.playersCount}/{data.maxPlayers}</span></p>
		</div>
	)
}